import React, {
  FunctionComponent,
  useEffect,
  useState,
} from "react";
import styles from "./Navbar.module.css";
import Logo from "../../Assets/Images/head.svg";
// import LogoNew from "../../Assets/Images/ify_logo_new.png";
import LogoNew from "../../Assets/Images/IFY_Magicbricks_Logo.png";
import HitBannerImage from '../../Assets/Images/HitBannerImage.png';
import ProjectListingBanner from '../../Assets/Images/ProjectListingBanner.webp';
import leadqualityBanner from '../../Assets/Images/leadqualityBanner.png';
import WhatsappBannerImage from '../../Assets/Images/whatsapp-banner.png';
import WhatsappFreeTrialBannerImage from '../../Assets/Images/whatsapp-free-trial-banner.png';
import LogoRightImage from '../../Assets/Images/LogoRightArrow.svg';
import classNames from "classnames";
import { AiOutlineArrowRight } from "react-icons/ai";
import { FaUserCircle } from "react-icons/fa";
import UserDetails from "../UserDetails/UserDetails";
import { connect, useDispatch} from "react-redux";
import ProfileImageModal from "../Modals/ProfileImageModal/ProfileImageModal";
import {setIsUsingApp, updateTheme} from "../../Redux/actions";
import {themeColors} from "../../Components/theme";
import DarkModeSwitch from "../../Components/DarkModeSwitch/DarkModeSwitch";
import SubscriptionAlert from "../../Components/SubscriptionAlert/SubscriptionAlert";
import { Link } from "react-router-dom";
import { display } from "@mui/system";
import { isUsingReadproApp } from "../../Services/users";
import { pushToGA,googleAnalytics } from "../../Services/users";
import AgentReverseFeedbackSlides from "../../Screens/AgentReverseFeedback/AgentReverseFeedbackSlides";
import CenteredPopUp from "../CenteredPopUp/CenteredPopUp";
import AgentReverseFeedbackThakyou from "../../Screens/AgentReverseFeedback/AgentReverseFeedbackThakyou";
import BroadcastSlides from "../../Screens/BroadcastSlides/BroadcastSlides";
import { deviceCheck } from "../../Values/utils";
import FreeTrialMarketingPopupContent from "../../Screens/FreeTrials/FreeTrialMarketingPopupContent";
import style from "../../Screens/FreeTrials/FreeTrialMarketingPopupContent.module.css"
import FreeTrialWhatappComponentV2 from "../../Screens/FreeTrials/FreeTrialWhatappComponentV2";
import FreeTrialWhatappComponentV1 from "../../Screens/FreeTrials/FreeTrialWhatappComponentV1";
import FreeTrialWhatsappModal from "../../Screens/FreeTrials/FreeTrialWhatsappModal";
import HtmlBanner from "../../bannerManagement/baneerComp"

type props = {
  props?: any;
  title:
  | "Organizations"
  | "Contacts"
  | "Users"
  | "Drilldown";
  path: string;
  leadManger: Boolean;
  project?: string;
  task?: string;
  resources?: string;
  callLogs?: string;
  faq?: string;
  user: any;
  api?: string;
  news?: string;
  apiData?: string;
  leadDistributor?: string;
  customButton?: string;
  isUsingApp?:boolean;
  theme:any;
  userRole: any;
  organization: any;
  hasActiveWAPackage: any;
  currentRoute?:any
};

const Navbar: FunctionComponent<props> = ({
  props,
  title,
  path,
  leadManger,
  project,
  task,
  resources,
  callLogs,
  faq,
  user,
  api,
  news,
  apiData,
  leadDistributor,
  customButton,
  theme,
  userRole,
  isUsingApp,
  organization,
  hasActiveWAPackage,
  currentRoute
}) => {
  const [showUserDetail, setShowUserDetails] =
    useState(false);
  const [expand, setExpand] = useState(false);
  const [profileModal, setProfileModal] = useState(false);
  const [showAgentReverseFeedbackSlide, setShowAgentReverseFeedbackSlide] = useState(false);
  const [showWhatsappSlides, setShowWhatsappSlides] = useState(false);
  const [showFreeTrialWhatappComponentV1, setShowFreeTrialWhatappComponentV1] = useState(false);
  const [showFreeTrialWhatappComponentV2, setShowFreeTrialWhatappComponentV2] = useState(false);
  const [showBanner, setShowBanner] = useState("");
  const [showFreeTrialModal, setShowFreeTrialModal] = useState(false);
  const [show,setShow] = useState(true);
  const dispatch = useDispatch();
  const todayDay = new Date().getDay();

  useEffect(() => {
    if (isUsingApp !== null && hasActiveWAPackage !== null && user.profile) {
      let showAgentFeedbackBanner = false;
      let showHighIntentBanner = false;
      let showWhatsappBanner = false;
      let showProjectListingBanner = false;

      if (
        organization.show_consent === "Y" &&
        (!organization.lead_reverse_feedback || organization.lead_reverse_feedback === "N") &&
        user.profile === "Admin" &&
        user.user_oid
      ) {
        showAgentFeedbackBanner = true;
      }
      if (
        organization.show_consent === "N" &&
        organization.show_feedback_popup === "Y" &&
        (!organization.lead_reverse_feedback || organization.lead_reverse_feedback === "N") &&
        user.profile === "Admin" &&
        user.user_oid
      ) {
        showAgentFeedbackBanner = true;
      }
      if (isUsingApp === false) {
        showHighIntentBanner = true;
      }
      if (hasActiveWAPackage === false && user.profile === "Admin" && user.user_oid) {
        showWhatsappBanner = true;
      }
      if (user.profile === "Admin" && user.user_oid) {
        showProjectListingBanner = true;
      }
      let path = window.location.pathname;
      let bannersToShow = [];
      if (path === "/contacts") {
        if (showAgentFeedbackBanner) bannersToShow.push("Agent_Reverse_Feedback_Banner");
        if (showHighIntentBanner) bannersToShow.push("High_Intent_Banner");
        if (showWhatsappBanner) bannersToShow.push("Whatsapp_Banner");
        if (showProjectListingBanner) bannersToShow.push("Project_Listing_Banner");
      } else {
        if (showWhatsappBanner) bannersToShow.push("Whatsapp_Banner");
        if (showAgentFeedbackBanner) bannersToShow.push("Agent_Reverse_Feedback_Banner");
        if (showHighIntentBanner) bannersToShow.push("High_Intent_Banner");
        if (showProjectListingBanner) bannersToShow.push("Project_Listing_Banner");
      }
      if (bannersToShow.length > 0) {
        let lastShownBanner = localStorage.getItem("lastShownBanner");

        // Get index of last shown banner and rotate
        let nextBanner = bannersToShow[0]; // Default to first
        if (lastShownBanner) {
          let lastIndex = bannersToShow.indexOf(lastShownBanner);
          if (lastIndex !== -1 && lastIndex < bannersToShow.length - 1) {
            nextBanner = bannersToShow[lastIndex + 1];
          }
        }

        setShowBanner(nextBanner);
        localStorage.setItem("lastShownBanner", nextBanner);
      }
    }
  }, [organization.show_consent, organization.lead_reverse_feedback, organization.show_feedback_popup, isUsingApp, user.profile, hasActiveWAPackage])

  useEffect(() => {
    let timeOut: any;
    if (showUserDetail === true) {
      setExpand(true);
      document.body.style.overflowX = "hidden";
      timeOut = setTimeout(() => {
        document.body.style.overflowX = "auto";
      }, 300);
    }
    return () => clearTimeout(timeOut);
  }, [showUserDetail]);
  useEffect(() => {
    let timeOut: any;
    if (expand === false) {
      document.body.style.overflowX = "hidden";
      timeOut = setTimeout(() => {
        setShowUserDetails(false);
        document.body.style.overflowX = "auto";
      }, 300);
    }
    return () => clearTimeout(timeOut);
  }, [expand]);

  const toggleUserDetails = () => {
    if (showUserDetail === false) {
      setShowUserDetails(true);
    } else {
      setExpand(false);
    }
  };

  useEffect(() => {
    const setUsingReadproApp = async () => {
      let usingApp = await isUsingReadproApp(user.user_oid);
      dispatch(setIsUsingApp(usingApp));
    };

    if (user.user_oid) {
      setUsingReadproApp();
    }
  }, [
    user.user_oid
  ]);

  const agentReversefeedbackhandler = () => {
    setShowAgentReverseFeedbackSlide(true)
    document.body.classList.add("no-overflow");
  }

   const agentReversefeedbackhandlerNew = (para:any) => {
    
    if(para==="a"){
      setShowAgentReverseFeedbackSlide(true)
    document.body.classList.add("no-overflow");
    }

    if(para==="w" && organization.WhatsAppTrialPack===true){
       if ([0, 1, 2, 3, 4, 5, 6].includes(todayDay)) {
                      setShowWhatsappSlides(false);
                      // setShowFreeTrialWhatappComponentV1(false); // Tue, Sun
                      setShowFreeTrialModal(true); 
                      // setShowFreeTrialWhatappComponentV2(false);
                    } 
                    // else if ([4, 6].includes(todayDay)) {
                    //   setShowFreeTrialWhatappComponentV2(true); // Thu, Sat
                    // }
                    let today = new Date();
                    localStorage.setItem('lastBroadcastSlideShowTime', JSON.stringify({
                      user_email: user.user_email,
                      date: today
                    }));
    }
  }

  // const containerStyles = {backgroundColor:theme ? themeColors.navbarBackgroundColor:themeColors.navbarBackgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark,borderRadius:0, boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.2), 0 3px 7px 0 rgba(0, 0, 0, 0.19)',zIndex:201}
  // const containerStyles = {
  //   backgroundColor: theme ? themeColors.navbarBackgroundColor : themeColors.navbarBackgroundColorDark,
  //   color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  //   borderRadius: 0,
  //   boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.2), 0 3px 7px 0 rgba(0, 0, 0, 0.19)',
  //   zIndex: 201,
  //   position: 'fixed', // Set the position to fixed
  //   width: '100%', // Make it full width
  // };
  const [showThankYou, setShowThankYou] = useState(false);
  // const [isGACalled, setIsGACalled] = useState<any>(false);
// console.log("showBanner",showBanner)
    // useEffect(()=>{
    //   if(showBanner === "Project_Listing_Banner" && isGACalled === false){
    //     if(user?.uid && user?.profile){
    //       setIsGACalled(true)
    //       // console.log("ga called on project listing tab")
    //       googleAnalytics('Project_Listing_Banner impression ',user)
    //     }
    //   }
    // },[user,showBanner])

    const [cRoute,setCRoute]=useState("")

    
   const [routeKey, setRouteKey] = useState(0);

  useEffect(() => {
    if (cRoute && currentRoute !== cRoute) {
      // If route has changed, re-render child
      setRouteKey((k) => k + 1);
    }
    setCRoute(currentRoute);
  }, [currentRoute]);
// console.log("currentRoute",currentRoute,cRoute)

  return (
    <div className="card d-flex flex-row justify-content-between align-items-center" 
    style={{
      backgroundColor: theme ? themeColors.navbarBackgroundColor : themeColors.navbarBackgroundColorDark,
      color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
      borderRadius: 0,
      boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.2), 0 3px 7px 0 rgba(0, 0, 0, 0.19)',
      zIndex: 201,
      // position: 'fixed', // Set the position to fixed
      // width: '100%', // Make it full width
    }}>
      {/* <div style={{display:"flex"}}> */}
      <img
        className={styles.logo}
        src={LogoNew}
        alt={"logo"}
      />
      {/* <div style={{ display: "flex", gap: "1rem", alignItems: "center", width: "fit-content", maxWidth: "280px" }}>
        <img
          className={styles.logo}
          src={LogoNew}
          alt={"logo"}
        />
        <img
          className={styles.logo}
          src={LogoRightImage}
          alt={"logo"}
        />
        {
          isUsingApp === false && (
            <span className={styles.DownloadApp} onClick={() => {
              pushToGA(
                "event_tracking",
                "read pro",
                "read pro",
                "top app link click",
                user,
                "Top_Navbar_Tab"
              )
              window.open("https://property.magicbricks.com/microsite/lp/download-readpro/?utm_source=web_app_download_banner_top&utm_medium=read_pro", "_blank");
            }}
            >
              Download
              App
            </span>
          )
        }
      </div> */}
      {/* {
        !deviceCheck() && show && (
          <>
            {
              showBanner === "Project_Listing_Banner" && (
                  <div className={`${styles.Hitbbanner} ${styles.ProjectListingBanner}`}onClick={() => {
                    pushToGA(
                      "event_tracking",
                      "read pro",
                      "read pro",
                      "Project_Listing_Banner click",
                      user,
                      "Top_Navbar_Tab | View all plans"
                    )
                  }}>
                    <a href="https://property.magicbricks.com/microsite/lp/magicbricks-pl-package/?utm_source=Readpro&utm_medium=Banner&utm_campaign=Project_listing" target="_blank">
                      <img
                        className={styles.HitBannerImage}
                        src={ProjectListingBanner}
                        alt={"ProjectListingBanner"}
                        width="100%"
                      />
                    </a>
                  </div>
                )
              }
            {
              showBanner === "High_Intent_Banner" && (
                <div className={styles.Hitbbanner} onClick={() => {
                  pushToGA(
                    "event_tracking",
                    "read pro",
                    "read pro",
                    "top app banner click",
                    user,
                    "Top_Navbar_Tab"
                  )
                }}>
                  <a href="https://property.magicbricks.com/microsite/lp/download-readpro/?utm_source=web_app_download_banner_top&utm_medium=read_pro" target="_blank">
                    <img
                      className={styles.HitBannerImage}
                      src={HitBannerImage}
                      alt={"HitBannerImage"}
                    />
                  </a>
                </div>
              )
            }
            {
              showBanner === "Agent_Reverse_Feedback_Banner" && (
                <div className={styles.Hitbbanner} onClick={() => {
                  pushToGA(
                    "event_tracking",
                    "read pro",
                    "read pro",
                    "top app lqc banner click",
                    user,
                    "Top_Navbar_Tab"
                  )
                }}>
                  <span onClick={agentReversefeedbackhandler}>
                    <img
                      className={styles.HitBannerImage}
                      src={leadqualityBanner}
                      alt={"leadqualityBanner"}
                    />
                  </span>
                </div>
              )
            }
            {
              showBanner === "Whatsapp_Banner" && (
                <div className={styles.Hitbbanner} onClick={() => {
                  pushToGA(
                    "event_tracking",
                    "read pro",
                    "read pro",
                    "top app whatsapp banner click",
                    user,
                    "Top_Navbar_Tab"
                  )
                }}>
                  <span onClick={() => {
                    // setShowWhatsappSlides(true);
                    if ([0, 1, 2, 3, 4, 5, 6].includes(todayDay)) {
                      setShowWhatsappSlides(false);
                      // setShowFreeTrialWhatappComponentV1(false); // Tue, Sun
                      setShowFreeTrialModal(true); 
                      // setShowFreeTrialWhatappComponentV2(false);
                    } 
                    // else if ([4, 6].includes(todayDay)) {
                    //   setShowFreeTrialWhatappComponentV2(true); // Thu, Sat
                    // }
                    let today = new Date();
                    localStorage.setItem('lastBroadcastSlideShowTime', JSON.stringify({
                      user_email: user.user_email,
                      date: today
                    }));
                  }}>
                    <img
                      className={styles.HitBannerImage}
                      src={ organization.WhatsAppTrialPack===true ? WhatsappFreeTrialBannerImage : WhatsappBannerImage}
                      alt={"whatsappBanner"}
                    />
                  </span>
                </div>
              )
            }
          </>
        )
      } */}

      {
        
       !deviceCheck() && (cRoute && (<div key={routeKey} className={styles.Hitbbanner}><HtmlBanner  user={user}  route={cRoute} bannerType={"navBanner"} setShow={setShow} agentReversefeedbackhandler={agentReversefeedbackhandlerNew}/></div> ))
      } 
      {showAgentReverseFeedbackSlide && 
        <AgentReverseFeedbackSlides 
          setShowAgentReverseFeedbackSlide = {setShowAgentReverseFeedbackSlide} setShowThankYou={setShowThankYou} />
      }
      {
        showThankYou &&
        <CenteredPopUp
          setModal={setShowThankYou}
          children={<AgentReverseFeedbackThakyou setShowThankYou={setShowThankYou} />}
          modiferClass={styles.AgentReverseFeedbackThanks}
          closeIcon={true}
        />
      }
      {
        showWhatsappSlides && (
          <CenteredPopUp
              setModal={setShowWhatsappSlides}
              children={<FreeTrialMarketingPopupContent />}
              modiferClass={style.FtmktPopup}
              closeIcon={true}
              popupName="Whatsapp_Marketing"
            />
        )
      }
      {
        showFreeTrialModal && 
        <CenteredPopUp 
            setModal={setShowFreeTrialModal}
            children={<FreeTrialWhatsappModal closePopup={setShowFreeTrialModal}/>}
            modiferClass={styles.ftmModal}
            closeIcon={true}
            closeClassMofifier={styles.ftmClose}
        />
    }
      {/* {
        showFreeTrialWhatappComponentV2 && (
          <CenteredPopUp
          setModal={setShowFreeTrialWhatappComponentV2}
          children={<FreeTrialWhatappComponentV2 closePopup={setShowFreeTrialWhatappComponentV2}/>}
          modiferClass={styles.FtmktPopupv2}
          closeIcon={true}
          closeClassMofifier={styles.FtmktPopupClosev2}
        />
        )
      }
      {
        showFreeTrialWhatappComponentV1 && (
          <CenteredPopUp
          setModal={setShowFreeTrialWhatappComponentV1}
          children={<FreeTrialWhatappComponentV1 closePopup={setShowFreeTrialWhatappComponentV1}/>}
          modiferClass={styles.FtmktPopupv1}
          closeIcon={true}
          closeClassMofifier={styles.FtmktPopupClosev1}
        />
        )
      } */}
      <div style={{display:"flex", justifyContent: "space-between"}}>
      {(title !== "Drilldown" && !deviceCheck()) && (
        <>          
          <div style={{marginLeft:"auto",marginRight:"2rem"}}>
          {userRole !== "superAdmin"  && userRole !== "organization" ? 
            <DarkModeSwitch /> :null} 
          </div>
          <p className={styles.text}>
            Profile
            <AiOutlineArrowRight
              size={18}
              style={{ marginLeft: "5px" }}
            />
          </p>
          <div className={styles.line} />
          <div className={styles.logOutView}>
            {user.user_image && user.user_image !== "" ? (
              <img
                alt="userImage"
                src={user.user_image}
                className={styles.image}
                onClick={toggleUserDetails}
              />
            ) : (
              <FaUserCircle
                color="#C0C0C0"
                size={25}
                onClick={toggleUserDetails}
              />
            )}
            {showUserDetail && (
              <div
                className={
                  expand
                    ? styles.userDetailExpand
                    : styles.userDetailClosed
                }
              >
                <UserDetails
                  showUserDetail={showUserDetail}
                  close={toggleUserDetails}
                  openModal={(data) =>
                    setProfileModal(data)
                  }
                />
              </div>
            )}
          </div>{" "}
        </>
      )}
      {profileModal && (
        <ProfileImageModal
          open={profileModal}
          close={() => setProfileModal(false)}
        />
      )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme:state.theme.isLightMode,
    userRole: state.user.role,
    isUsingApp: state.user.isUsingApp,
    organization: state.organization,
    hasActiveWAPackage: state.organization.hasActiveWAPackage,
    currentRoute:state.currentRoute.initialParams
  };
};

export default connect(mapStateToProps)(Navbar);